import React, { useState, MouseEvent, useRef, ChangeEvent } from 'react';
import styled from 'styled-components';
import {
  Panel,
  Label,
  Card,
  Heading,
  Button,
  TextInput,
  FormControl,
  Select,
} from '@uhg-harmony/uitk-react';
import Checkbox from '@mui/material/Checkbox';
import {
  Arrow,
  MuiOptionsWrapper,
  StyledRadio,
} from 'builder/scenes/SiteBuilder/SettingsPanel/SettingsPanel';
import {
  SizeLocationData,
  WidgetSizeLocation,
} from '../../../builder/components/WidgetSizeLocation';
import { Config } from './types';
import { Border } from 'builder/components/WidgetConfigurations/Border';
import {
  BackgroundData,
  Background,
} from 'builder/components/WidgetConfigurations/Background/Background';
import { StyledPanel, StyledPanelTitle } from '../Text/TextWidgetControl';
import { Popover } from '@material-ui/core';
import RepeaterDataTable from './RepeaterDataTable';
import { RepeaterWidgetInitialData, widgetTypes } from 'builder/util/constants';
import {
  MainLabelStyles,
  FontSelect,
  FontSizeInput,
  StyleWrapper,
  TextIconWrapper,
  StyledIcon,
  FontSizeInputWrapper,
} from 'builder/components/WidgetConfigurations/Typography/Typography';
import {
  IconBold,
  IconItalic,
  IconStrikethrough,
  IconUnderline,
} from '@tabler/icons-react';
import { getCombinedFontsForTheme } from 'builder/util/getCombinedFonts';
import GradientColorPicker, {
  StyledPickerWrapper,
  StyledPickerHeader,
  StyledClose,
  StyledPickerPopover,
} from 'builder/components/GradientColorPicker/GradientColorPicker';
import { ColorButton } from 'builder/components/ColorButton/ColorButton';
import { ColorButtonWrapper } from 'builder/components/WidgetConfigurations/Background/Background';

// Local styled components to match Typography layout
const StyledWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const FontSizeUnitStyle = styled.span`
  color: #1d1929;
  font-size: 12px;
  margin-left: 4px;
`;
import { getWidget } from '..';
import uuidv4 from 'uuid/v4';
import { useDispatch } from 'react-redux';
import { updateWidgetConfig } from 'shared/state/ducks/sites';
import { getInitialChildren } from 'builder/util/getInitialChildren';
import * as XLSX from 'xlsx';
import {
  fetchContentFromHorizon,
  saveOrUpdateContentToHorizon,
} from 'shared/api/horizonContentApi';
import { toast } from 'react-toastify';
import {
  mapContainersToFilteredRows,
  mapContainersToPaginatedRows,
  cloneExtraChildrenFromReference,
  PER_INSTANCE_PROPERTIES,
  getInsertContainerIndex,
} from './RepeaterUtils';
import _ from 'lodash';
import { Link } from 'shared/theme/link-ui-react/Link';
import {
  FormControl as MUIFormControl,
  RadioGroup,
  TextField,
} from '@mui/material';
import { FormControlLabel } from '@material-ui/core';
import { RequiredFieldWrapper } from 'builder/components/WidgetConfigurations/EnableFullScreenWidth';
import { ContainerSpacing } from 'builder/components/WidgetConfigurations/ContainerSpacing/ContainerSpacing';
import { ContainerSpacingData } from './types';
// import { FileDownloadIcon } from '@uitk/react-icons';

const SizeLocationPanel = styled(Panel)`
  > div {
    padding: 1rem;
  }
`;

const CustomLink = styled(Link)`
  font-family: 'OptumSans';
  font-size: 2rem;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px #888888;
  color: ${p => p.theme.colors.aux.darkBlue};
  &:hover {
    color: ${p => p.theme.colors.aux.darkBlue};
  }
`;

const ManageEventPopover = styled(Popover)`
  margin-top: 100px;
  .MuiPaper-root {
    overflow-x: auto;
    overflow-y: auto;
    margin-left: -30px;
    width: 800px; /* Match the width of StyledCard */
  }
`;

const StyledCard = styled(Card)`
  & div[class^='Cardcomponent__Content'] {
    padding: 1rem;
  }
  height: 100%; /* Add this line to make the card fit the height of its parent div */
  width: 800px;
  border: none;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem; /* Added margin */
`;

const StyledHeading = styled(Heading)`
  color: black;
  margin-right: auto;
`;

const HeaderButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  margin: 5px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem; /* Added margin */
`;

const HeaderContainerImport = styled.div`
  margin-left: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem; /* Added margin */
`;

const StyledImportHeadingText = styled.div`
  margin-left: 1rem;
  font-family: 'OptumSans';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
`;

const ParentContainer = styled.div`
  display: flex;
`;

const BorderContainer = styled.div`
  margin-left: 1rem;
  border: 1rem;
  background-color: rgba(25, 110, 207, 1);
  width: 5px;
`;

const HeadingContainer = styled.div`
  padding: 1rem;
  font-size: 16px;
  background-color: rgba(25, 110, 207, 0.047058823529411764);
`;

const HeadingImport = styled.h2`
  font-family: 'OptumSans';
  color: #253c8d;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-left: 1rem;
  padding-left: 1rem;
`;

const StyledBullet = styled.li`
  font-family: 'OptumSans';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 26px;
  list-style-type: disc;
  margin-left: 20px;
`;

const Container = styled.div`
  display: flex;
  align-items: center; /* Align items vertically centered */
  margin: 1px;
  margin-left: 1rem;
`;
const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
`;

const BrowseContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 2px;
`;

const StyledTextHeadingDownload = styled.div`
  font-family: 'OptumSans';
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
`;

const CirclePoint = styled.div`
  font-family: 'OptumSans';
  width: 35px;
  height: 35px;
  background-color: rgb(25, 110, 207);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  margin-right: 20px;
`;

const StyledText = styled.div`
  font-family: 'OptumSans';
  color: #899198;
  font-size: 16px;
  margin: 0;
`;

const StyledLink = styled.a`
  color: rgb(0, 0, 255);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledDataDropdowns = styled.div`
  display: flex;
  align-items: center;
`;

const StyledConnections = styled(Select)`
  margin-right: 0.5rem;
  width: 12rem;
  border-radius: 0.375rem;
  padding-left: 25px;
  & > select {
    font-family: OptumSans, sans-serif;
    line-height: 1.25rem;
  }
`;

export const LabelStyles = styled(Label)`
  color: #1d1929;
  font-size: 14px;
  font-family: OptumSans;
  font-weight: 500;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: bold;
`;

/**
 * Shifts mapped data indices to make room for an inserted repeater row.
 *
 * @param repeaterDataMapping - Container IDs mapped to their data-row indices.
 * @param insertIndex - Zero-based index where the new row will be inserted.
 * @returns Nothing; the supplied mapping is updated in place.
 */
const shiftRepeaterDataMappingForInsertion = (
  repeaterDataMapping: Record<string, number>,
  insertIndex: number
): void => {
  Object.keys(repeaterDataMapping).forEach(containerId => {
    if (repeaterDataMapping[containerId] >= insertIndex) {
      repeaterDataMapping[containerId] += 1;
    }
  });
};

const RepeaterWidgetControl: React.FC<WidgetControlProps<Config>> = (
  props: WidgetControlProps<Config>
) => {
  const {
    value,
    onChange,
    widgetState,
    site,
    updateCurrentPage,
    updateSite,
    saveSite,
  } = props;
  const { id: activeWidgetId } = props.widgetState;
  const [childWidgets, setChildWidgets] = useState([]);
  const [widgetDataConnections, setWidgetDataConnections] = useState(
    widgetState.config?.widgetDataConnections || []
  );
  const [importEventEnabled, setImportEventEnabled] = useState(false);
  const [manageEvents, setManageEvents] = useState(false);
  const [
    eventSectionAnchorEl,
    setEventSectionAnchorEl,
  ] = useState<SVGElement | null>(null);
  const editSectionOpen = Boolean(eventSectionAnchorEl);
  const editItemId = editSectionOpen ? 'edit-link-popover' : undefined;

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [repeaterData, setRepeaterData] = useState(
    widgetState.config.repeaterData
  );
  const [dataExists, setDataExists] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const popOveropen = Boolean(anchorEl);
  const [containerCount, setContainerCount] = useState(
    widgetState.config.containerCount
  );
  const deletedRowIndexRef = React.useRef<number | null>(null);
  const deletionInProgressRef = React.useRef<boolean>(false);
  const insertedRowIndexRef = React.useRef<number | null>(null);
  const [filtering, setFiltering] = useState(
    widgetState.config.enableFiltering
  );
  const [filterBy, setFilterBy] = useState(widgetState.config.filterBy);
  const [layout, setLayout] = useState(
    widgetState.config.layout || 'horizontal'
  );
  const [itemsCount, setItemsCount] = useState(
    widgetState.config.itemsCount || 3
  );
  const [enablePagination, setEnablePagination] = useState(
    widgetState.config.enablePagination || false
  );

  const [paginatedItemsPerPage, setPaginatedItemsPerPage] = useState(
    widgetState.config.paginatedItemsPerPage
  );

  // Sidebar styling state variables
  const [sidebarBackgroundColor, setSidebarBackgroundColor] = useState(
    widgetState.config.sidebarBackgroundColor || '#f3f3f3'
  );
  const [sidebarHeadingFont, setSidebarHeadingFont] = useState(
    widgetState.config.sidebarHeadingFont || 'OptumSans'
  );
  const [sidebarHeadingFontSize, setSidebarHeadingFontSize] = useState(
    widgetState.config.sidebarHeadingFontSize || '14'
  );
  const [sidebarHeadingBold, setSidebarHeadingBold] = useState<boolean>(
    widgetState.config.sidebarHeadingBold ?? true
  );
  const [sidebarHeadingItalic, setSidebarHeadingItalic] = useState<boolean>(
    widgetState.config.sidebarHeadingItalic ?? false
  );
  const [sidebarHeadingUnderline, setSidebarHeadingUnderline] = useState<
    boolean
  >(widgetState.config.sidebarHeadingUnderline ?? false);
  const [
    sidebarHeadingStrikeThrough,
    setSidebarHeadingStrikeThrough,
  ] = useState<boolean>(
    widgetState.config.sidebarHeadingStrikeThrough ?? false
  );
  const [sidebarHeadingColor, setSidebarHeadingColor] = useState(
    widgetState.config.sidebarHeadingTextColor || '#1d1929'
  );
  const [sidebarOptionFont, setSidebarOptionFont] = useState(
    widgetState.config.sidebarOptionFont || 'OptumSans'
  );
  const [sidebarOptionFontSize, setSidebarOptionFontSize] = useState(
    widgetState.config.sidebarOptionFontSize || '14'
  );
  const [sidebarOptionBold, setSidebarOptionBold] = useState<boolean>(
    widgetState.config.sidebarOptionBold ?? false
  );
  const [sidebarOptionItalic, setSidebarOptionItalic] = useState<boolean>(
    widgetState.config.sidebarOptionItalic ?? false
  );
  const [sidebarOptionUnderline, setSidebarOptionUnderline] = useState<boolean>(
    widgetState.config.sidebarOptionUnderline ?? false
  );
  const [sidebarOptionStrikeThrough, setSidebarOptionStrikeThrough] = useState<
    boolean
  >(widgetState.config.sidebarOptionStrikeThrough ?? false);
  const [sidebarOptionColor, setSidebarOptionColor] = useState(
    widgetState.config.sidebarOptionTextColor || '#1d1929'
  );

  // Simple checkbox button color for checked/hover states
  const [checkboxButtonColor, setCheckboxButtonColor] = useState(
    widgetState.config.checkboxButtonColor || '#002677'
  );

  // Color picker state for proper GradientColorPicker functionality (following Background/Border pattern)
  const [pickerOpen, setPickerOpen] = useState(false);
  const colorButtonRef = useRef<HTMLDivElement | null>(null);
  const pickerId = pickerOpen ? 'sidebar-color-picker-popover' : undefined;

  // Container spacing state
  const [containerHorizontalSpacing, setContainerHorizontalSpacing] = useState<
    number
  >(widgetState.config.containerHorizontalSpacing ?? 33);
  const [containerVerticalSpacing, setContainerVerticalSpacing] = useState<
    number
  >(widgetState.config.containerVerticalSpacing ?? 23);

  console.log(containerHorizontalSpacing, containerVerticalSpacing);

  const dispatch = useDispatch();

  //add and delete containers dynamically
  React.useEffect(() => {
    if (!props.currentPage || !activeWidgetId) return;

    const repeater = props.currentPage?.content[activeWidgetId];

    const firstContainerId = repeater.children.find(childId => {
      const child = props.currentPage?.content[childId];
      return child?.config?.repeaterWidgetIndex === 1;
    });

    if (!firstContainerId) return;

    const firstContainer = props.currentPage?.content[firstContainerId];
    const widgets = firstContainer.children
      .map(id => props.currentPage?.content[id])
      .filter(widget => widget.type !== widgetTypes.Section)
      .sort((a, b) => a.config.repeaterWidgetId - b.config.repeaterWidgetId);

    setChildWidgets(widgets);
  }, [props.currentPage, activeWidgetId]);

  React.useEffect(() => {
    let updatedRepeaterConfig = { ...widgetState.config };
    updatedRepeaterConfig.containerCount = containerCount;
    updatedRepeaterConfig.repeaterData = repeaterData;
    const currentContainerCount = widgetState.children.length;
    const containersPerRow = itemsCount;
    const vSpacing = widgetState.config.containerVerticalSpacing ?? 23;

    // Use actual container height from the first existing container instead of hardcoded value
    const firstContainerId = widgetState.children?.[0];
    const firstContainerHeight = firstContainerId
      ? props.currentPage?.content[firstContainerId]?.config?.height
      : null;

    if (layout === 'horizontal') {
      const requiredRowCount = Math.ceil(containerCount / containersPerRow);
      const currentRowCount = Math.ceil(
        currentContainerCount / containersPerRow
      );
      const rowHeight = firstContainerHeight ?? 338;
      const rowHeightWithSpacing = rowHeight + vSpacing;

      //Height adjustment logic
      if (requiredRowCount > currentRowCount) {
        // Add height if new row added
        const heightDiff =
          (requiredRowCount - currentRowCount) * rowHeightWithSpacing;
        updatedRepeaterConfig.height += heightDiff;
      } else if (requiredRowCount < currentRowCount) {
        // Reduce height if row removed
        const heightDiff =
          (currentRowCount - requiredRowCount) * rowHeightWithSpacing;
        updatedRepeaterConfig.height = Math.max(
          updatedRepeaterConfig.height - heightDiff,
          rowHeight
        );
      }
    } else {
      // vertical layout
      const containerHeight = firstContainerHeight ?? 338;
      const containerHeightWithSpacing = containerHeight + vSpacing;
      const requiredHeight = containerCount * containerHeightWithSpacing;

      updatedRepeaterConfig.height = Math.max(requiredHeight, containerHeight);
    }

    if (updatedRepeaterConfig.height !== widgetState.config.height) {
      dispatch(
        updateWidgetConfig(
          site?.siteId,
          props.currentPage?.pageId,
          activeWidgetId,
          updatedRepeaterConfig,
          false
        )
      );
    }

    // Handle Container Addition — skip if a deletion is still propagating through Redux
    if (
      containerCount > currentContainerCount &&
      !deletionInProgressRef.current
    ) {
      addContainers(
        containersPerRow,
        updatedRepeaterConfig,
        currentContainerCount,
        containerCount
      );
    }

    //Handle Container Deletion
    if (containerCount < currentContainerCount) {
      deletionInProgressRef.current = true;
      deleteContainer(deletedRowIndexRef.current);
      deletedRowIndexRef.current = null;
    }
  }, [containerCount]);

  // Clear the deletion-in-progress flag once Redux children count matches containerCount
  React.useEffect(() => {
    if (
      deletionInProgressRef.current &&
      widgetState.children.length <= containerCount
    ) {
      deletionInProgressRef.current = false;
    }
  }, [widgetState.children.length, containerCount]);

  function createChildWidgets(
    initialWidgetConfig,
    parentWidgetConfig,
    sectionConfig,
    parentSectionWidgetId
  ) {
    const widget = getWidget(initialWidgetConfig.widgetType, true);

    // Calculate child position relative to parent container
    const childDeltaX = initialWidgetConfig.x - sectionConfig.x;
    const childDeltaY = initialWidgetConfig.y - sectionConfig.y;

    // Use the reference child's full config as base when available,
    // otherwise fall back to the widget type's default initialConfig
    const baseConfig =
      initialWidgetConfig.referenceConfig || widget.initialConfig;

    let defaultChildConfig = {
      ...baseConfig,
      visible: true,
      xLocation: parentWidgetConfig.x + childDeltaX,
      yLocation: parentWidgetConfig.y + childDeltaY,
      x: parentWidgetConfig.x + childDeltaX,
      y: parentWidgetConfig.y + childDeltaY,
      width: initialWidgetConfig.width,
      height: initialWidgetConfig.height,
      minWidth: initialWidgetConfig.minWidth,
      minHeight: initialWidgetConfig.minHeight,
      parentId: parentSectionWidgetId,
      repeaterWidgetKey:
        widgetDataConnections[initialWidgetConfig.repeaterWidgetId] ??
        initialWidgetConfig.repeaterWidgetKey,
      repeaterWidgetId: initialWidgetConfig.repeaterWidgetId,
    };

    const widgetId = uuidv4();
    props.addChild(
      initialWidgetConfig.widgetType,
      defaultChildConfig,
      0,
      widgetId,
      defaultChildConfig.parentId,
      initialWidgetConfig.tabIndex
    );
  }

  function addContainers(
    containersPerRow,
    updatedRepeaterConfig,
    existingContainerCount,
    containerCount
  ) {
    const initialWidgetConfig = getInitialChildren(widgetTypes.RepeaterWidget);
    const sectionChildWidgetConfigs = getInitialChildren(
      'RepeaterSectionChildren'
    );
    const repeaterDataMapping = { ...widgetState.config.repeaterDataMapping };

    // When a row was inserted in the middle, shift existing mappings so
    // each container continues to point to the same logical data row.
    const insertIdx = insertedRowIndexRef.current;
    const insertContainerIndex = getInsertContainerIndex(
      insertIdx,
      existingContainerCount,
      containerCount
    );
    if (insertIdx != null) {
      shiftRepeaterDataMappingForInsertion(repeaterDataMapping, insertIdx);
      insertedRowIndexRef.current = null;
    }

    // Helper: find the next data index not yet assigned in repeaterDataMapping
    const assignedIndices = new Set(Object.values(repeaterDataMapping));
    let _nextUnassigned = 0;
    const getNextUnassignedIndex = () => {
      while (assignedIndices.has(_nextUnassigned)) _nextUnassigned++;
      const idx = _nextUnassigned;
      assignedIndices.add(idx);
      _nextUnassigned++;
      return idx;
    };

    const hSpacing = widgetState.config.containerHorizontalSpacing ?? 33;
    const vSpacing = widgetState.config.containerVerticalSpacing ?? 23;

    // When inserting in the middle, shift existing containers at/after the
    // insert position so the new container can be placed at the required slot.
    if (insertContainerIndex != null) {
      const firstTemplateForShift = initialWidgetConfig[0];
      const containersToShift = (widgetState.children || [])
        .map(id => {
          const config = props.currentPage?.content[id]?.config;
          return {
            id,
            index: config?.repeaterWidgetIndex,
            config,
          };
        })
        .filter(
          container =>
            container.config &&
            typeof container.index === 'number' &&
            container.index >= insertContainerIndex
        )
        .sort((a, b) => a.index - b.index);

      containersToShift.forEach(container => {
        const currentConfig = container.config;
        const newIndex = container.index + 1;

        const refWidth = currentConfig.width ?? firstTemplateForShift.width;
        const refHeight = currentConfig.height ?? firstTemplateForShift.height;

        let newX = currentConfig.xLocation;
        let newY = currentConfig.yLocation;

        if (layout === 'horizontal') {
          const rowNumber = Math.floor((newIndex - 1) / containersPerRow);
          const positionInRow = (newIndex - 1) % containersPerRow;
          const xOffset =
            firstTemplateForShift.x + (refWidth + hSpacing) * positionInRow;
          const yOffset =
            firstTemplateForShift.y + (refHeight + vSpacing) * rowNumber;
          newX = widgetState.config.xLocation + xOffset;
          newY = widgetState.config.yLocation + yOffset;
        } else {
          const yOffset =
            firstTemplateForShift.y + (refHeight + vSpacing) * (newIndex - 1);
          newX = widgetState.config.xLocation + firstTemplateForShift.x;
          newY = widgetState.config.yLocation + yOffset;
        }

        const deltaX = newX - currentConfig.xLocation;
        const deltaY = newY - currentConfig.yLocation;

        dispatch(
          updateWidgetConfig(
            site?.siteId,
            props.currentPage?.pageId,
            container.id,
            {
              ...currentConfig,
              repeaterWidgetIndex: newIndex,
              xLocation: newX,
              yLocation: newY,
              x: newX,
              y: newY,
            },
            false
          )
        );

        if (deltaX !== 0 || deltaY !== 0) {
          const containerChildren =
            props.currentPage?.content[container.id]?.children || [];
          containerChildren.forEach(childId => {
            const childConfig = props.currentPage?.content[childId]?.config;
            if (!childConfig) return;
            dispatch(
              updateWidgetConfig(
                site?.siteId,
                props.currentPage?.pageId,
                childId,
                {
                  ...childConfig,
                  xLocation: childConfig.xLocation + deltaX,
                  yLocation: childConfig.yLocation + deltaY,
                  x: (childConfig.x ?? childConfig.xLocation) + deltaX,
                  y: (childConfig.y ?? childConfig.yLocation) + deltaY,
                },
                false
              )
            );
          });
        }
      });
    }

    // Collect template repeaterWidgetIds so we can identify manually-added children
    const templateRepeaterWidgetIds = new Set<number>();
    sectionChildWidgetConfigs.forEach((sectionChildren: any[]) => {
      sectionChildren.forEach((child: any) => {
        if (child.repeaterWidgetId != null) {
          templateRepeaterWidgetIds.add(child.repeaterWidgetId);
        }
      });
    });

    // Use the first existing container as the reference for cloning extra children
    // and copying visual attributes (height, background, border, etc.)
    const referenceContainerId = widgetState.children?.[0] || null;
    const referenceConfig = referenceContainerId
      ? props.currentPage?.content[referenceContainerId]?.config
      : null;

    // Build child widget configs from the reference container's actual state
    // so that updated layouts (position/size changes) are preserved in new containers
    let effectiveChildConfigs = sectionChildWidgetConfigs;
    let referenceSectionConfig: { x: number; y: number } | null = null;
    if (
      referenceContainerId &&
      props.currentPage?.content[referenceContainerId]
    ) {
      const refChildren =
        props.currentPage.content[referenceContainerId].children || [];
      const templateChildren = refChildren
        .map(childId => {
          const childContent = props.currentPage?.content[childId];
          if (!childContent) return null;
          return {
            id: childId,
            type: childContent.type,
            config: childContent.config,
          };
        })
        .filter(
          child => child != null && child.config?.repeaterWidgetId != null
        );

      if (templateChildren.length > 0) {
        referenceSectionConfig = {
          x:
            referenceConfig?.xLocation ??
            referenceConfig?.x ??
            initialWidgetConfig[0].x,
          y:
            referenceConfig?.yLocation ??
            referenceConfig?.y ??
            initialWidgetConfig[0].y,
        };
        // Build a single array of child configs matching the structure createChildWidgets expects
        // Include the full reference config so child widgets inherit all updated properties
        // but exclude per-instance properties that should not carry over to new containers
        const referenceChildArray = templateChildren.map(child => {
          const filteredConfig = { ...child!.config };
          PER_INSTANCE_PROPERTIES.forEach(prop => delete filteredConfig[prop]);
          return {
            widgetType: child!.type,
            x: child!.config.xLocation ?? child!.config.x,
            y: child!.config.yLocation ?? child!.config.y,
            width: child!.config.width,
            height: child!.config.height,
            minWidth: child!.config.minWidth,
            minHeight: child!.config.minHeight,
            repeaterWidgetId: child!.config.repeaterWidgetId,
            repeaterWidgetKey: child!.config.repeaterWidgetKey,
            tabIndex: child!.config.tabIndex ?? 0,
            referenceConfig: filteredConfig,
          };
        });
        // Use the same child config array for all container positions
        effectiveChildConfigs = initialWidgetConfig.map(
          () => referenceChildArray
        );
      }
    }

    if (layout === 'horizontal') {
      const firstTemplate = initialWidgetConfig[0]; // Always use first template as base

      for (let i = existingContainerCount + 1; i <= containerCount; i++) {
        const insertionOffset = i - (existingContainerCount + 1);
        const containerIndex =
          insertContainerIndex != null
            ? insertContainerIndex + insertionOffset
            : i;
        const sectionConfigIndex = (containerIndex - 1) % containersPerRow;
        const sectionConfig = initialWidgetConfig[sectionConfigIndex];
        const rowNumber = Math.floor((containerIndex - 1) / containersPerRow);
        const positionInRow = (containerIndex - 1) % containersPerRow;
        const widget = getWidget(sectionConfig.widgetType, true);

        const baseConfig = referenceConfig || widget.initialConfig;

        // Calculate x position: use first template's x as base + (container width + horizontal spacing) * position in row
        const refWidth = referenceConfig?.width ?? firstTemplate.width;
        const refHeightH = referenceConfig?.height ?? firstTemplate.height;
        const xOffset = firstTemplate.x + (refWidth + hSpacing) * positionInRow;

        // Calculate y position: use first template's y as base + (container height + vertical spacing) * row number
        const yOffset = firstTemplate.y + (refHeightH + vSpacing) * rowNumber;
        const defaultChildConfig = {
          ...baseConfig,
          visible: true,
          xLocation: widgetState.config.xLocation + xOffset,
          yLocation: widgetState.config.yLocation + yOffset,
          x: widgetState.config.xLocation + xOffset,
          y: widgetState.config.yLocation + yOffset,
          width: referenceConfig?.width ?? sectionConfig.width,
          height: referenceConfig?.height ?? sectionConfig.height,
          minWidth: referenceConfig?.minWidth ?? sectionConfig.minWidth,
          minHeight: referenceConfig?.minHeight ?? sectionConfig.minHeight,
          parentId: activeWidgetId,
          repeaterWidgetIndex: containerIndex,
        };

        const widgetId = uuidv4();
        props.addChild(
          sectionConfig.widgetType,
          defaultChildConfig,
          0,
          widgetId,
          defaultChildConfig.parentId,
          sectionConfig.tabIndex
        );

        repeaterDataMapping[widgetId] = getNextUnassignedIndex();

        const childWidgetTemplate = effectiveChildConfigs[sectionConfigIndex];
        if (childWidgetTemplate) {
          const childSectionOrigin = referenceSectionConfig || sectionConfig;
          childWidgetTemplate.forEach(childWidget => {
            createChildWidgets(
              childWidget,
              defaultChildConfig,
              childSectionOrigin,
              widgetId
            );
          });
        }

        // Clone any manually-added children from the reference container
        if (referenceContainerId && props.currentPage) {
          cloneExtraChildrenFromReference({
            referenceContainerId,
            newContainerId: widgetId,
            newContainerConfig: defaultChildConfig,
            templateRepeaterWidgetIds,
            currentPage: props.currentPage,
            siteId: site?.siteId as number,
            pageId: props.currentPage?.pageId,
            dispatch,
          });
        }
      }
    } else {
      // vertical layout
      for (let i = existingContainerCount + 1; i <= containerCount; i++) {
        const insertionOffset = i - (existingContainerCount + 1);
        const containerIndex =
          insertContainerIndex != null
            ? insertContainerIndex + insertionOffset
            : i;
        const sectionConfigIndex = 0;
        const sectionConfig = initialWidgetConfig[sectionConfigIndex];
        const widget = getWidget(sectionConfig.widgetType, true);

        const baseConfig = referenceConfig || widget.initialConfig;
        const refHeight = referenceConfig?.height ?? sectionConfig.height;

        // Calculate y position: base position + (container height + vertical spacing) * (index - 1)
        const yOffset =
          sectionConfig.y + (refHeight + vSpacing) * (containerIndex - 1);
        const defaultChildConfig = {
          ...baseConfig,
          visible: true,
          xLocation: widgetState.config.xLocation + sectionConfig.x,
          yLocation: widgetState.config.yLocation + yOffset,
          x: widgetState.config.xLocation + sectionConfig.x,
          y: widgetState.config.yLocation + yOffset,
          width: referenceConfig?.width ?? sectionConfig.width,
          height: refHeight,
          minWidth: referenceConfig?.minWidth ?? sectionConfig.minWidth,
          minHeight: referenceConfig?.minHeight ?? sectionConfig.minHeight,
          parentId: activeWidgetId,
          repeaterWidgetIndex: containerIndex,
        };

        const widgetId = uuidv4();
        props.addChild(
          sectionConfig.widgetType,
          defaultChildConfig,
          0,
          widgetId,
          defaultChildConfig.parentId,
          sectionConfig.tabIndex
        );

        repeaterDataMapping[widgetId] = getNextUnassignedIndex();

        const childSectionOriginV = referenceSectionConfig || sectionConfig;
        effectiveChildConfigs[sectionConfigIndex].forEach(childWidget => {
          createChildWidgets(
            childWidget,
            defaultChildConfig,
            childSectionOriginV,
            widgetId
          );
        });

        // Clone any manually-added children from the reference container
        if (referenceContainerId && props.currentPage) {
          cloneExtraChildrenFromReference({
            referenceContainerId,
            newContainerId: widgetId,
            newContainerConfig: defaultChildConfig,
            templateRepeaterWidgetIds,
            currentPage: props.currentPage,
            siteId: site?.siteId as number,
            pageId: props.currentPage?.pageId,
            dispatch,
          });
        }
      }
    }

    dispatch(
      updateWidgetConfig(
        site?.siteId,
        props.currentPage?.pageId,
        activeWidgetId,
        {
          ...updatedRepeaterConfig,
          repeaterDataMapping: repeaterDataMapping,
        },
        false
      )
    );
  }

  function deleteContainer(deletedRowIndex: number | null) {
    const containerIds = [...widgetState.children];

    // Map containers with their repeaterWidgetIndex
    const containersWithIndex = containerIds
      .map(id => ({
        id,
        index:
          props.currentPage?.content[id]?.config?.repeaterWidgetIndex ?? -1,
      }))
      .sort((a, b) => a.index - b.index);

    // Determine which container to delete:
    // If deletedRowIndex is provided, delete the container at that position (1-based index = deletedRowIndex + 1)
    // Otherwise fall back to deleting the last container
    const targetIndex =
      deletedRowIndex != null
        ? deletedRowIndex + 1
        : containersWithIndex[containersWithIndex.length - 1]?.index;

    const containerToDelete = containersWithIndex.find(
      c => c.index === targetIndex
    );

    if (containerToDelete) {
      const childWidgets =
        props.currentPage?.content[containerToDelete.id]?.children || [];
      childWidgets.forEach(childId => props.removeWidget(childId));

      props.removeWidget(containerToDelete.id);

      // Re-index remaining containers and reposition them to close the gap
      const remainingContainers = containersWithIndex.filter(
        c => c.id !== containerToDelete.id
      );
      const updatedRepeaterDataMapping = {};

      const initialWidgetConfig = getInitialChildren(
        widgetTypes.RepeaterWidget
      );
      const firstTemplate = initialWidgetConfig[0];
      const hSpacing = widgetState.config.containerHorizontalSpacing ?? 33;
      const vSpacing = widgetState.config.containerVerticalSpacing ?? 23;
      const containersPerRow = itemsCount;

      remainingContainers.forEach((container, idx) => {
        const newIndex = idx + 1;
        const currentConfig = props.currentPage?.content[container.id]?.config;
        if (!currentConfig) return;

        const refWidth = currentConfig.width ?? firstTemplate.width;
        const refHeight = currentConfig.height ?? firstTemplate.height;

        let newX: number;
        let newY: number;

        if (layout === 'horizontal') {
          const rowNumber = Math.floor(idx / containersPerRow);
          const positionInRow = idx % containersPerRow;
          const xOffset =
            firstTemplate.x + (refWidth + hSpacing) * positionInRow;
          const yOffset = firstTemplate.y + (refHeight + vSpacing) * rowNumber;
          newX = widgetState.config.xLocation + xOffset;
          newY = widgetState.config.yLocation + yOffset;
        } else {
          // vertical layout
          const yOffset = firstTemplate.y + (refHeight + vSpacing) * idx;
          newX = widgetState.config.xLocation + firstTemplate.x;
          newY = widgetState.config.yLocation + yOffset;
        }

        // Calculate the position delta for child widgets
        const deltaX = newX - currentConfig.xLocation;
        const deltaY = newY - currentConfig.yLocation;

        // Update container position and index
        dispatch(
          updateWidgetConfig(
            site?.siteId,
            props.currentPage?.pageId,
            container.id,
            {
              ...currentConfig,
              repeaterWidgetIndex: newIndex,
              xLocation: newX,
              yLocation: newY,
              x: newX,
              y: newY,
            },
            false
          )
        );

        // Reposition child widgets relative to the container's new position
        if (deltaX !== 0 || deltaY !== 0) {
          const containerChildren =
            props.currentPage?.content[container.id]?.children || [];
          containerChildren.forEach(childId => {
            const childConfig = props.currentPage?.content[childId]?.config;
            if (childConfig) {
              dispatch(
                updateWidgetConfig(
                  site?.siteId,
                  props.currentPage?.pageId,
                  childId,
                  {
                    ...childConfig,
                    xLocation: childConfig.xLocation + deltaX,
                    yLocation: childConfig.yLocation + deltaY,
                    x: (childConfig.x ?? childConfig.xLocation) + deltaX,
                    y: (childConfig.y ?? childConfig.yLocation) + deltaY,
                  },
                  false
                )
              );
            }
          });
        }

        updatedRepeaterDataMapping[container.id] = idx;
      });

      // Update repeaterDataMapping and containerCount on the repeater widget config
      dispatch(
        updateWidgetConfig(
          site?.siteId,
          props.currentPage?.pageId,
          activeWidgetId,
          {
            ...widgetState.config,
            containerCount: remainingContainers.length,
            repeaterDataMapping: updatedRepeaterDataMapping,
            // Persist the row-removed data too. Spreading widgetState.config alone
            // would keep the deleted row in repeaterData, leaving its tag in the
            // filter panel and letting the deleted container reappear on filter.
            repeaterData,
          },
          false
        )
      );
    }
  }

  const updateWidgetSizeLoction = (sizeLoc: SizeLocationData) => {
    onChange({
      ...value,
      width: sizeLoc.width,
      height: sizeLoc.height,
      xLocation: sizeLoc.xLocation,
      yLocation: sizeLoc.yLocation,
      uniqueId: sizeLoc.uniqueId,
    });
  };
  const updateBorderData = (data: BorderData) => {
    onChange({
      ...value,
      borderData: data,
    });
  };

  const updateContainerSpacingData = (data: ContainerSpacingData) => {
    setContainerHorizontalSpacing(data.containerHorizontalSpacing);
    setContainerVerticalSpacing(data.containerVerticalSpacing);

    onChange({
      ...value,
      containerHorizontalSpacing: data.containerHorizontalSpacing,
      containerVerticalSpacing: data.containerVerticalSpacing,
    });

    // Update widget config with new spacing
    const updatedConfig = {
      ...widgetState.config,
      containerHorizontalSpacing: data.containerHorizontalSpacing,
      containerVerticalSpacing: data.containerVerticalSpacing,
    };

    dispatch(
      updateWidgetConfig(
        site?.siteId,
        props.currentPage?.pageId,
        activeWidgetId,
        updatedConfig,
        false
      )
    );

    // Immediately reposition all existing containers with new spacing
    const repeaterWidget = props.currentPage?.content[activeWidgetId];
    const containerIds = repeaterWidget?.children || [];
    const itemsCount = widgetState.config.itemsCount;
    const hSpacing = data.containerHorizontalSpacing;
    const vSpacing = data.containerVerticalSpacing;

    const firstContainerId = containerIds.find(containerId => {
      const container = props.currentPage?.content[containerId];
      return container?.config?.repeaterWidgetIndex === 1;
    });

    if (firstContainerId) {
      const firstContainer = props.currentPage?.content[firstContainerId];

      if (widgetState.config.layout === 'vertical') {
        // Vertical layout: reposition containers vertically with spacing
        containerIds.forEach(containerId => {
          if (containerId !== firstContainerId) {
            const container = props.currentPage?.content[containerId];
            const updatedContainerConfig = {
              ...container.config,
              xLocation: firstContainer.config.xLocation,
              yLocation:
                firstContainer.config.yLocation +
                (firstContainer.config.height + vSpacing) *
                  (container.config.repeaterWidgetIndex - 1),
              x: firstContainer.config.xLocation,
              y:
                firstContainer.config.yLocation +
                (firstContainer.config.height + vSpacing) *
                  (container.config.repeaterWidgetIndex - 1),
            };

            dispatch(
              updateWidgetConfig(
                site.siteId,
                props.currentPage.pageId,
                containerId,
                updatedContainerConfig,
                false
              )
            );

            // Update child widgets
            const childWidgets = container.children || [];
            childWidgets?.forEach(childId => {
              const childWidget = props.currentPage?.content[childId];
              const childWidgetDeltaX =
                childWidget.config.xLocation - container.config.xLocation;
              const childWidgetDeltaY =
                childWidget.config.yLocation - container.config.yLocation;

              const updatedChildConfig = {
                ...childWidget.config,
                xLocation: updatedContainerConfig.xLocation + childWidgetDeltaX,
                yLocation: updatedContainerConfig.yLocation + childWidgetDeltaY,
                x: updatedContainerConfig.xLocation + childWidgetDeltaX,
                y: updatedContainerConfig.yLocation + childWidgetDeltaY,
              };
              dispatch(
                updateWidgetConfig(
                  site.siteId,
                  props.currentPage.pageId,
                  childId,
                  updatedChildConfig,
                  false
                )
              );
            });
          }
        });

        // Update repeater widget height
        const deltaY =
          firstContainer.config.yLocation - widgetState.config.yLocation;
        const updatedRepeaterConfig = {
          ...updatedConfig,
          height:
            deltaY * 2 +
            firstContainer.config.height * containerIds.length +
            vSpacing * (containerIds.length - 1),
        };
        dispatch(
          updateWidgetConfig(
            site.siteId,
            props.currentPage.pageId,
            activeWidgetId,
            updatedRepeaterConfig,
            false
          )
        );
      } else {
        // Horizontal layout: reposition containers with spacing
        containerIds.forEach(containerId => {
          if (containerId !== firstContainerId) {
            const container = props.currentPage?.content[containerId];
            const positionInRow =
              (container.config.repeaterWidgetIndex - 1) % itemsCount;
            const rowNumber = Math.floor(
              (container.config.repeaterWidgetIndex - 1) / itemsCount
            );

            const xOffset =
              (firstContainer.config.width + hSpacing) * positionInRow;
            const yOffset =
              (firstContainer.config.height + vSpacing) * rowNumber;

            const updatedContainerConfig = {
              ...container.config,
              xLocation: firstContainer.config.xLocation + xOffset,
              yLocation: firstContainer.config.yLocation + yOffset,
              x: firstContainer.config.xLocation + xOffset,
              y: firstContainer.config.yLocation + yOffset,
            };

            dispatch(
              updateWidgetConfig(
                site.siteId,
                props.currentPage.pageId,
                containerId,
                updatedContainerConfig,
                false
              )
            );

            // Update child widgets
            const childWidgets = container.children || [];
            childWidgets?.forEach(childId => {
              const childWidget = props.currentPage?.content[childId];
              const childWidgetDeltaX =
                childWidget.config.xLocation - container.config.xLocation;
              const childWidgetDeltaY =
                childWidget.config.yLocation - container.config.yLocation;

              const updatedChildConfig = {
                ...childWidget.config,
                xLocation: updatedContainerConfig.xLocation + childWidgetDeltaX,
                yLocation: updatedContainerConfig.yLocation + childWidgetDeltaY,
                x: updatedContainerConfig.xLocation + childWidgetDeltaX,
                y: updatedContainerConfig.yLocation + childWidgetDeltaY,
              };
              dispatch(
                updateWidgetConfig(
                  site.siteId,
                  props.currentPage.pageId,
                  childId,
                  updatedChildConfig,
                  false
                )
              );
            });
          }
        });

        // Update repeater widget dimensions
        const deltaX =
          firstContainer.config.xLocation - widgetState.config.xLocation;
        const deltaY =
          firstContainer.config.yLocation - widgetState.config.yLocation;
        const totalRows = Math.ceil(containerIds.length / itemsCount);
        const updatedRepeaterConfig = {
          ...updatedConfig,
          width:
            deltaX * 2 +
            firstContainer.config.width * itemsCount +
            hSpacing * (itemsCount - 1),
          height:
            deltaY * 2 +
            firstContainer.config.height * totalRows +
            vSpacing * (totalRows - 1),
        };
        dispatch(
          updateWidgetConfig(
            site.siteId,
            props.currentPage.pageId,
            activeWidgetId,
            updatedRepeaterConfig,
            false
          )
        );
      }
    }
  };

  const updateBackgroundData = (data: BackgroundData) => {
    if (data.style === 'None') {
      onChange({
        ...value,
        backgroundData: {
          style: data.style,
          color: 'transparent',
        },
      });
    } else {
      onChange({
        ...value,
        backgroundData: data,
      });
    }
  };
  const updateBackgroundImage = (data: Image) => {
    onChange({
      ...value,
      backgroundImage: data,
    });
  };
  const handleLineColor = data => {
    onChange({
      ...value,
      lineColor: data,
    });
  };

  const handleBackgroundColor = (data: string) => {
    if (data === 'None') {
      onChange({
        ...value,
        backgroundData: {
          style: data,
          color: 'transparent',
        },
      });
    } else {
      onChange({
        ...value,
        backgroundData: {
          ...value.backgroundData,
          color: data,
        },
      });
    }
  };

  const handleItemsCountChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newItemsCount = e.target.value;

    if (newItemsCount === '') {
      setItemsCount(undefined);
      return;
    }

    setItemsCount(parseInt(newItemsCount));

    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage.pageId,
        widgetState.id,
        {
          ...props.currentPage?.content[widgetState.id].config,
          itemsCount: parseInt(newItemsCount),
        },
        false
      )
    );

    updateContainersLayout(
      widgetState.config.layout,
      widgetState,
      parseInt(newItemsCount)
    );
  };

  const handleEnablePaginationChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setEnablePagination(isChecked);

    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage.pageId,
        widgetState.id,
        {
          ...props.currentPage?.content[widgetState.id].config,
          enablePagination: isChecked,
          paginatedItemsPerPage: isChecked
            ? paginatedItemsPerPage || 9
            : undefined,
          currentPaginationPage: isChecked ? 1 : undefined,
        },
        false
      )
    );

    mapContainersToPaginatedRows(
      widgetState.id,
      isChecked,
      props.currentPage,
      repeaterData,
      isChecked ? paginatedItemsPerPage || 9 : undefined,
      dispatch,
      site.siteId,
      props.currentPage.pageId,
      1
    );
  };

  const handlePaginatedItemsPerPageChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const newPaginatedItemsPerPage = e.target.value;

    if (newPaginatedItemsPerPage === '') {
      setPaginatedItemsPerPage(undefined);
      return;
    }

    const parsedValue = parseInt(newPaginatedItemsPerPage);

    if (!isNaN(parsedValue) && parsedValue > 0) {
      setPaginatedItemsPerPage(parsedValue);

      dispatch(
        updateWidgetConfig(
          site.siteId,
          props.currentPage.pageId,
          widgetState.id,
          {
            ...props.currentPage?.content[widgetState.id].config,
            paginatedItemsPerPage: parsedValue,
          },
          false
        )
      );

      mapContainersToPaginatedRows(
        widgetState.id,
        true,
        props.currentPage,
        repeaterData,
        parsedValue,
        dispatch,
        site.siteId,
        props.currentPage.pageId,
        1
      );
    } else if (
      newPaginatedItemsPerPage !== '' &&
      (isNaN(parsedValue) || parsedValue <= 0)
    ) {
      return;
    }
  };

  function handleInputClick(event: MouseEvent<HTMLInputElement>): void {
    event.stopPropagation();
  }

  const handleClose = (e: MouseEvent<any>) => {
    e.stopPropagation();
    e.preventDefault();
    setEventSectionAnchorEl(null);
  };

  const handleImportEvent = () => {
    setImportEventEnabled(true);
    setManageEvents(false);
    // setAddEvent(false);
    // setEditEvent(false);
  };

  const handlePopoverOpen = async (event: React.MouseEvent<HTMLElement>) => {
    setManageEvents(true);
    // setAddEvent(false);
    // setEditEvent(false);
    setImportEventEnabled(false);
    setAnchorEl(event.currentTarget);
    // props.fetchEventList(widgetState.id);
    try {
      const response = await fetchContentFromHorizon(
        props.site.siteId,
        props.currentPage?.pageId,
        widgetState.id
      );
      if (response.content && response.content.length > 0) {
        const contentJson = JSON.parse(response.content[0].content);
        setDataExists(true);
        setRepeaterData(contentJson);

        dispatch(
          updateWidgetConfig(
            site?.siteId,
            props.currentPage?.pageId,
            widgetState.id,
            {
              ...widgetState.config,
              repeaterData: contentJson,
            },
            false
          )
        );
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setDataExists(false);
        setRepeaterData(RepeaterWidgetInitialData);

        dispatch(
          updateWidgetConfig(
            site?.siteId,
            props.currentPage?.pageId,
            widgetState.id,
            {
              ...widgetState.config,
              repeaterData: RepeaterWidgetInitialData,
            },
            false
          )
        );
      } else {
        console.error('Error fetching content:', error);
      }
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleFilteringChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiltering = e.target.checked;
    setFiltering(selectedFiltering);
    onChange({
      ...value,
      enableFiltering: e.target.checked,
    });

    const liveConfig = props.currentPage?.content[widgetState.id]?.config;

    dispatch(
      updateWidgetConfig(
        site?.siteId,
        props.currentPage?.pageId,
        widgetState.id,
        {
          ...liveConfig,
          enableFiltering: selectedFiltering,
        },
        false
      )
    );

    const patchedPage = _.cloneDeep(props.currentPage);
    patchedPage.content[
      widgetState.id
    ].config.enableFiltering = selectedFiltering;

    mapContainersToFilteredRows({
      widgetId: widgetState.id,
      currentPage: patchedPage,
      repeaterData: patchedPage.content[widgetState.id].config.repeaterData,
      filterBy: patchedPage.content[widgetState.id].config?.filterBy,
      enableFiltering: e.target.checked,
      dispatch,
      siteId: site.siteId,
      pageId: patchedPage.pageId,
      updateCurrentPage,
    });
  };

  const handleFilterByChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    const selectedFilterBy = e.target.value;

    setFilterBy(selectedFilterBy);

    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage?.pageId,
        widgetState.id,
        {
          ...props.currentPage?.content[widgetState.id]?.config,
          filterBy: selectedFilterBy,
        },
        false
      )
    );

    const patchedPage = _.cloneDeep(props?.currentPage);
    if (patchedPage) {
      patchedPage.content[widgetState.id].config.filterBy = selectedFilterBy;
    }

    mapContainersToFilteredRows({
      widgetId: widgetState.id,
      currentPage: patchedPage,
      repeaterData: patchedPage?.content[widgetState.id].config.repeaterData,
      filterBy: selectedFilterBy,
      enableFiltering:
        patchedPage?.content[widgetState.id].config.enableFiltering,
      dispatch,
      siteId: site.siteId,
      pageId: patchedPage?.pageId,
      updateCurrentPage,
    });
  };

  // Sidebar styling handlers
  const updateSidebarConfig = (updates: Partial<Config>) => {
    const updatedConfig = {
      ...props.currentPage?.content[widgetState.id]?.config,
      ...updates,
    };

    onChange({
      ...value,
      ...updates,
    });

    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage?.pageId,
        widgetState.id,
        updatedConfig,
        false
      )
    );
  };

  const handleSidebarBackgroundColorChange = (color: string) => {
    setSidebarBackgroundColor(color);
    updateSidebarConfig({ sidebarBackgroundColor: color });
  };

  const handleSidebarHeadingFontChange = (
    e: ChangeEvent<HTMLSelectElement>
  ) => {
    const font = e.target.value;
    setSidebarHeadingFont(font);
    updateSidebarConfig({ sidebarHeadingFont: font });
  };

  const handleSidebarHeadingFontSizeChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const fontSize = e.target.value;
    setSidebarHeadingFontSize(fontSize);
    updateSidebarConfig({ sidebarHeadingFontSize: fontSize });
  };

  const handleSidebarHeadingBoldToggle = () => {
    const newBold = !sidebarHeadingBold;
    setSidebarHeadingBold(newBold);
    updateSidebarConfig({ sidebarHeadingBold: newBold });
  };

  const handleSidebarHeadingItalicToggle = () => {
    const newItalic = !sidebarHeadingItalic;
    setSidebarHeadingItalic(newItalic);
    updateSidebarConfig({ sidebarHeadingItalic: newItalic });
  };

  const handleSidebarHeadingUnderlineToggle = () => {
    const newUnderline = !sidebarHeadingUnderline;
    setSidebarHeadingUnderline(newUnderline);
    updateSidebarConfig({ sidebarHeadingUnderline: newUnderline });
  };

  const handleSidebarHeadingStrikeThroughToggle = () => {
    const newStrikeThrough = !sidebarHeadingStrikeThrough;
    setSidebarHeadingStrikeThrough(newStrikeThrough);
    updateSidebarConfig({ sidebarHeadingStrikeThrough: newStrikeThrough });
  };

  const handleSidebarHeadingColorChange = (color: string) => {
    setSidebarHeadingColor(color);
    updateSidebarConfig({ sidebarHeadingTextColor: color });
  };

  const handleSidebarOptionFontChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const font = e.target.value;
    setSidebarOptionFont(font);
    updateSidebarConfig({ sidebarOptionFont: font });
  };

  const handleSidebarOptionFontSizeChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const fontSize = e.target.value;
    setSidebarOptionFontSize(fontSize);
    updateSidebarConfig({ sidebarOptionFontSize: fontSize });
  };

  const handleSidebarOptionBoldToggle = () => {
    const newBold = !sidebarOptionBold;
    setSidebarOptionBold(newBold);
    updateSidebarConfig({ sidebarOptionBold: newBold });
  };

  const handleSidebarOptionItalicToggle = () => {
    const newItalic = !sidebarOptionItalic;
    setSidebarOptionItalic(newItalic);
    updateSidebarConfig({ sidebarOptionItalic: newItalic });
  };

  const handleSidebarOptionUnderlineToggle = () => {
    const newUnderline = !sidebarOptionUnderline;
    setSidebarOptionUnderline(newUnderline);
    updateSidebarConfig({ sidebarOptionUnderline: newUnderline });
  };

  const handleSidebarOptionStrikeThroughToggle = () => {
    const newStrikeThrough = !sidebarOptionStrikeThrough;
    setSidebarOptionStrikeThrough(newStrikeThrough);
    updateSidebarConfig({ sidebarOptionStrikeThrough: newStrikeThrough });
  };

  const handleSidebarOptionColorChange = (color: string) => {
    setSidebarOptionColor(color);
    updateSidebarConfig({ sidebarOptionTextColor: color });
  };

  // Color picker handlers following Background/Border pattern
  const handleColorEditClick = (e: React.MouseEvent<any>) => {
    e.stopPropagation();
    e.preventDefault();
    colorButtonRef.current = e.currentTarget as HTMLDivElement;
    setPickerOpen(true);
  };

  const handlePickerClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handlePickerClose = (e: React.MouseEvent<any>) => {
    e.stopPropagation();
    setPickerOpen(false);
    colorButtonRef.current = null;
  };

  const handleColorChange = (newColor: string) => {
    if (colorButtonRef.current?.id === 'sidebar-background-color') {
      handleSidebarBackgroundColorChange(newColor);
    }
    if (colorButtonRef.current?.id === 'sidebar-heading-color') {
      handleSidebarHeadingColorChange(newColor);
    }
    if (colorButtonRef.current?.id === 'sidebar-option-color') {
      handleSidebarOptionColorChange(newColor);
    }
    // Simple checkbox button color handler
    if (colorButtonRef.current?.id === 'checkbox-button-color') {
      handleCheckboxButtonColorChange(newColor);
    }
  };

  // Simple checkbox button color handler
  const handleCheckboxButtonColorChange = (color: string) => {
    setCheckboxButtonColor(color);
    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage.pageId,
        widgetState.id,
        { ...widgetState.config, checkboxButtonColor: color },
        false
      )
    );
  };

  const handleLayoutChange = (e: any) => {
    const selectedLayout = e.target.value;
    setLayout(selectedLayout);

    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage.pageId,
        widgetState.id,
        {
          ...props.currentPage?.content[widgetState.id].config,
          layout: selectedLayout,
        },
        false
      )
    );

    updateContainersLayout(selectedLayout, widgetState);
  };

  function updateContainersLayout(
    layout: string,
    widgetState: any,
    items?: number
  ) {
    const repeaterWidget = props.currentPage?.content[widgetState.id];
    const containerIds = repeaterWidget.children || [];
    const itemsCount = items || widgetState.config.itemsCount;
    const hSpacing = widgetState.config.containerHorizontalSpacing ?? 33;
    const vSpacing = widgetState.config.containerVerticalSpacing ?? 23;

    const firstContainerId = containerIds.find(containerId => {
      const container = props.currentPage?.content[containerId];
      return container?.config?.repeaterWidgetIndex === 1;
    });
    const firstContainer = props.currentPage?.content[firstContainerId];
    const deltaY =
      firstContainer.config.yLocation - widgetState.config.yLocation;
    const deltaX =
      firstContainer.config.xLocation - widgetState.config.xLocation;

    if (layout === 'vertical') {
      containerIds.forEach(containerId => {
        if (containerId !== firstContainerId) {
          const container = props.currentPage?.content[containerId];
          const updatedConfig = {
            ...container.config,
            xLocation: firstContainer.config.xLocation,
            yLocation:
              firstContainer.config.yLocation +
              (firstContainer.config.height + vSpacing) *
                (container.config.repeaterWidgetIndex - 1),
            x: firstContainer.config.xLocation,
            y:
              firstContainer.config.yLocation +
              (firstContainer.config.height + vSpacing) *
                (container.config.repeaterWidgetIndex - 1),
          };

          dispatch(
            updateWidgetConfig(
              site.siteId,
              props.currentPage.pageId,
              containerId,
              updatedConfig,
              false
            )
          );

          const childWidgets = container.children || [];
          childWidgets?.forEach(childId => {
            const childWidget = props.currentPage?.content[childId];
            const childWidgetDeltaX =
              childWidget.config.xLocation - container.config.xLocation;
            const childWidgetDeltaY =
              childWidget.config.yLocation - container.config.yLocation;

            const updatedChildConfig = {
              ...childWidget.config,
              xLocation: updatedConfig.xLocation + childWidgetDeltaX,
              yLocation: updatedConfig.yLocation + childWidgetDeltaY,
              x: updatedConfig.xLocation + childWidgetDeltaX,
              y: updatedConfig.yLocation + childWidgetDeltaY,
            };
            dispatch(
              updateWidgetConfig(
                site.siteId,
                props.currentPage.pageId,
                childId,
                updatedChildConfig,
                false
              )
            );
          });
        }
      });

      const updatedRepeaterConfig = {
        ...widgetState.config,
        width:
          (firstContainer.config.xLocation - repeaterWidget.config.xLocation) *
            2 +
          firstContainer.config.width,
        height:
          deltaY * 2 +
          firstContainer.config.height * containerIds.length +
          vSpacing * (containerIds.length - 1),
        layout: 'vertical',
      };
      dispatch(
        updateWidgetConfig(
          site.siteId,
          props.currentPage.pageId,
          widgetState.id,
          updatedRepeaterConfig,
          false
        )
      );
    } else {
      // Horizontal layout: reposition containers with spacing
      containerIds.forEach(containerId => {
        if (containerId !== firstContainerId) {
          const container = props.currentPage?.content[containerId];
          const positionInRow =
            (container.config.repeaterWidgetIndex - 1) % itemsCount;
          const rowNumber = Math.floor(
            (container.config.repeaterWidgetIndex - 1) / itemsCount
          );

          const xOffset =
            (firstContainer.config.width + hSpacing) * positionInRow;
          const yOffset = (firstContainer.config.height + vSpacing) * rowNumber;

          const updatedConfig = {
            ...container.config,
            xLocation: firstContainer.config.xLocation + xOffset,
            yLocation: firstContainer.config.yLocation + yOffset,
            x: firstContainer.config.xLocation + xOffset,
            y: firstContainer.config.yLocation + yOffset,
          };

          dispatch(
            updateWidgetConfig(
              site.siteId,
              props.currentPage.pageId,
              containerId,
              updatedConfig,
              false
            )
          );

          const childWidgets = container.children || [];
          childWidgets?.forEach(childId => {
            const childWidget = props.currentPage?.content[childId];
            const childWidgetDeltaX =
              childWidget.config.xLocation - container.config.xLocation;
            const childWidgetDeltaY =
              childWidget.config.yLocation - container.config.yLocation;

            const updatedChildConfig = {
              ...childWidget.config,
              xLocation: updatedConfig.xLocation + childWidgetDeltaX,
              yLocation: updatedConfig.yLocation + childWidgetDeltaY,
              x: updatedConfig.xLocation + childWidgetDeltaX,
              y: updatedConfig.yLocation + childWidgetDeltaY,
            };
            dispatch(
              updateWidgetConfig(
                site.siteId,
                props.currentPage.pageId,
                childId,
                updatedChildConfig,
                false
              )
            );
          });
        }
      });

      const totalRows = Math.ceil(containerIds.length / itemsCount);
      const updatedRepeaterConfig = {
        ...widgetState.config,
        width:
          deltaX * 2 +
          firstContainer.config.width * itemsCount +
          hSpacing * (itemsCount - 1),
        height:
          deltaY * 2 +
          firstContainer.config.height * totalRows +
          vSpacing * (totalRows - 1),
        layout: 'horizontal',
      };
      dispatch(
        updateWidgetConfig(
          site.siteId,
          props.currentPage.pageId,
          widgetState.id,
          updatedRepeaterConfig,
          false
        )
      );
    }
  }

  const handleBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      // Process the file here
    }
  };

  const handleBulkSaveClick = () => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = async event => {
        const data = new Uint8Array(event.target.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json<Record<string, any>>(worksheet);
        // check to extract the headers which doesn't have any records
        const headerFromSheet = XLSX.utils.sheet_to_json<Record<string, any>>(
          worksheet,
          { header: 1 }
        );
        const tempHeaders = headerFromSheet[0] as string[];

        const headers = Array.from(
          new Set([...Object.keys(json[0]), ...tempHeaders])
        );

        headers.push('index');

        const dataRows = json.map((row, index) => ({
          ...row,
          index: index + 1,
        }));

        let outputJson;
        if (dataExists) {
          const existingHeaders = repeaterData.headers;
          const existingData = repeaterData.data;

          const mergedHeaders = Array.from(
            new Set([...existingHeaders, ...headers])
          );

          const combinedData = [...existingData, ...dataRows];

          const mergedData = combinedData.map((row, i) => {
            const newRow: Record<string, any> = {};
            mergedHeaders.forEach(header => {
              newRow[header] = row[header] !== undefined ? row[header] : '';
            });
            newRow.index = i + 1;
            return newRow;
          });

          outputJson = {
            headers: mergedHeaders,
            data: mergedData,
          };
        } else {
          const normalizedDataRows = dataRows.map((row, index) => {
            const newRow = { index: index + 1 };
            headers.forEach(header => {
              newRow[header] = row[header] !== undefined ? row[header] : '';
            });
            return newRow;
          });

          outputJson = {
            headers: headers,
            data: normalizedDataRows,
          };
        }
        setRepeaterData(outputJson);

        dispatch(
          updateWidgetConfig(
            site?.siteId,
            props.currentPage?.pageId,
            widgetState.id,
            {
              ...widgetState.config,
              repeaterData: outputJson,
            },
            false
          )
        );

        setContainerCount(outputJson.data.length);

        const jsonString = JSON.stringify(outputJson);
        const siteId = props.site.siteId;
        const pageId = props.currentPage?.pageId;
        const widgetId = widgetState.id;

        saveOrUpdateContentToHorizon(siteId, pageId, widgetId, jsonString)
          .then(() => {
            toast('Content saved successfully', {
              type: 'success',
              theme: 'colored',
            });
            setSelectedFile(null);
            handlePopoverClose();
          })
          .catch(error => {
            toast('Error saving content.', { type: 'error', theme: 'colored' });
            console.error('Error saving content:', error);
          });
      };
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  const handleSaveClick = () => {
    const jsonString = JSON.stringify(repeaterData);
    const siteId = props.site.siteId;
    const pageId = props.currentPage?.pageId;
    const widgetId = widgetState.id;
    saveOrUpdateContentToHorizon(siteId, pageId, widgetId, jsonString)
      .then(() => {
        toast('Content saved successfully', {
          type: 'success',
          theme: 'colored',
        });
        handlePopoverClose();
      })
      .catch(error => {
        toast('Error saving content.', { type: 'error', theme: 'colored' });
        console.error('Error saving content:', error);
      });
  };

  const handleConnectionChange = (widget, selectedHeader) => {
    const childWidgetIndex = widget.config.repeaterWidgetId;

    // const selectedHeader = selected === '' ? null : selected;

    const updatedConnections = {
      ...widgetState.config.widgetDataConnections,
      [childWidgetIndex]: selectedHeader,
    };

    setWidgetDataConnections(updatedConnections);

    // Auto-update imageColumnNames when Image widget connections change
    let updatedImageColumns = [...(widgetState.config.imageColumnNames || [])];
    if (widget.type === widgetTypes.Image) {
      // Remove old column name if previously connected
      const oldColumnName =
        widgetState.config.widgetDataConnections?.[childWidgetIndex];
      if (oldColumnName) {
        updatedImageColumns = updatedImageColumns.filter(
          col => col !== oldColumnName
        );
      }
      // Add new column name
      if (selectedHeader && !updatedImageColumns.includes(selectedHeader)) {
        updatedImageColumns.push(selectedHeader);
      }
    }

    // Update Parent Repeater Widget Config
    dispatch(
      updateWidgetConfig(
        site.siteId,
        props.currentPage?.pageId,
        widgetState.id,
        {
          ...widgetState.config,
          widgetDataConnections: updatedConnections,
          imageColumnNames: updatedImageColumns,
        },
        false
      )
    );

    updateAllContainersChildrenDataMapping(childWidgetIndex, selectedHeader);
  };

  const updateAllContainersChildrenDataMapping = (
    widgetIndex,
    selectedHeader
  ) => {
    widgetState.children.forEach(containerId => {
      const container = props.currentPage?.content[containerId];
      container?.children?.forEach(childId => {
        const childWidget = props.currentPage?.content[childId];
        if (childWidget.config?.repeaterWidgetId === widgetIndex) {
          dispatch(
            updateWidgetConfig(
              site.siteId,
              props.currentPage?.pageId,
              childId,
              {
                ...childWidget.config,
                repeaterWidgetKey: selectedHeader,
              },
              false
            )
          );
        }
      });
    });
  };

  return (
    <>
      <Panel.Group data-test-id="repeater-control-panel">
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>General</Label>}
            icon={Arrow}
            data-test-id="general-section-panel"
          >
            <CustomLink
              underline
              onClick={handlePopoverOpen}
              data-testid="popover-open-btn"
            >
              Manage Data Fields
            </CustomLink>
            <ManageEventPopover
              id={editItemId}
              open={popOveropen}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorReference="anchorEl"
              anchorOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'center',
                horizontal: 'right',
              }}
              data-test-id="edit-link-popover"
            >
              {manageEvents && (
                <>
                  <StyledCard>
                    <HeaderContainer>
                      <StyledHeading level="h4">
                        Manage Data Fields
                      </StyledHeading>
                      <HeaderButtonContainer>
                        <StyledButton
                          variant="tertiary"
                          onPress={handleImportEvent}
                          // icon={<FileDownloadIcon />}
                          iconLeft
                          data-testid="import-event-btn"
                        >
                          Import Data Fields
                        </StyledButton>
                      </HeaderButtonContainer>
                    </HeaderContainer>
                    <RepeaterDataTable
                      jsonData={repeaterData}
                      setRepeaterData={setRepeaterData}
                      setContainerCount={setContainerCount}
                      onDeleteRow={(rowIndex: number) => {
                        deletedRowIndexRef.current = rowIndex;
                      }}
                      onInsertRow={(rowIndex: number) => {
                        insertedRowIndexRef.current = rowIndex;
                      }}
                      site={site}
                      widgetState={widgetState}
                      currentPage={props.currentPage}
                      imageColumns={widgetState.config.imageColumnNames || []}
                      onImageColumnsChange={updatedImageColumns => {
                        dispatch(
                          updateWidgetConfig(
                            site.siteId,
                            props.currentPage?.pageId,
                            widgetState.id,
                            {
                              ...widgetState.config,
                              imageColumnNames: updatedImageColumns,
                            },
                            false
                          )
                        );
                      }}
                    />
                    <ButtonContainer>
                      <StyledButton
                        variant="primary"
                        className={'mr-xs mt-s'}
                        onPress={handleSaveClick}
                        data-test-id="popover-save-btn"
                      >
                        Save
                      </StyledButton>
                      <StyledButton
                        variant="secondary"
                        onPress={handlePopoverClose}
                        data-testid="popover-close-btn"
                      >
                        Cancel
                      </StyledButton>
                    </ButtonContainer>
                  </StyledCard>
                </>
              )}
              {importEventEnabled && !manageEvents && (
                <div onAbort={handleInputClick}>
                  <StyledCard>
                    <HeaderContainerImport>
                      <StyledHeading level="h4">
                        Import Data Fields
                      </StyledHeading>
                    </HeaderContainerImport>
                    <StyledImportHeadingText>
                      Importing fields allows you to import many fields at time
                      from a pre-made template.
                    </StyledImportHeadingText>
                    <ParentContainer>
                      <BorderContainer />
                      <HeadingContainer>
                        <HeadingImport> Tips for Best Results</HeadingImport>
                        <StyledBullet>
                          Only import the template that we have provided for
                          you. Any other templates will not work.
                        </StyledBullet>
                        <StyledBullet>
                          All template fields should have data in them. A field
                          that is missing data may not be added successfully.
                        </StyledBullet>
                      </HeadingContainer>
                    </ParentContainer>

                    <Container>
                      <CirclePoint>1</CirclePoint>
                      <InnerContainer>
                        <StyledTextHeadingDownload>
                          Download Template
                        </StyledTextHeadingDownload>
                        <StyledText>
                          Get our file template by
                          <StyledLink
                            href="https://cdn-stage.linkhealth.com/site-builder/horizon/repeater_template.xlsx"
                            download
                          >
                            {' '}
                            clicking here
                          </StyledLink>
                          .
                        </StyledText>
                      </InnerContainer>
                    </Container>
                    <Container>
                      <CirclePoint>2</CirclePoint>
                      <InnerContainer>
                        <StyledTextHeadingDownload>
                          Import Completed Template
                        </StyledTextHeadingDownload>
                        <BrowseContainer>
                          <TextInput
                            type="text"
                            value={selectedFile ? selectedFile.name : ''}
                            readOnly
                            style={{ 'margin-right': '1rem' }}
                            data-test-id="file-name-input"
                          />
                          <Button
                            variant="tertiary"
                            onPress={handleBrowseClick}
                            data-testid="browse-btn"
                          >
                            Browse
                          </Button>
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            accept=".xls,.xlsx"
                            onChange={handleFileChange}
                            data-testid="file-input"
                            data-test-id="repeater-file-input"
                          />
                        </BrowseContainer>
                      </InnerContainer>
                    </Container>
                    <ButtonContainer>
                      <StyledButton
                        variant="primary"
                        className={'mr-xs mt-s'}
                        onPress={handleBulkSaveClick}
                        data-testid="bulk-save-btn"
                      >
                        Save
                      </StyledButton>
                      <StyledButton
                        variant="secondary"
                        onPress={handlePopoverClose}
                        data-test-id="bulk-cancel-btn"
                      >
                        Cancel
                      </StyledButton>
                    </ButtonContainer>
                  </StyledCard>
                </div>
              )}
            </ManageEventPopover>
            <MainLabelStyles>Enable Filtering</MainLabelStyles>
            <Checkbox
              data-test-id="arrows-checkbox"
              checked={filtering}
              onChange={handleFilteringChange}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 25 } }}
            />
            {filtering && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <MainLabelStyles style={{ marginTop: '10px' }}>
                  Filter By
                </MainLabelStyles>
                <FormControl
                  data-test-id="filter-by-dropdown"
                  id="filter-controlled-select"
                >
                  <StyledConnections
                    onChange={handleFilterByChange}
                    value={filterBy}
                    data-test-id="filter-select"
                  >
                    <option value="">Select column</option>
                    {widgetState.config.repeaterData.headers
                      .filter(
                        header => header !== 'index' && header !== 'Add Column'
                      )
                      .map(header => {
                        return (
                          <option key={header} value={header}>
                            {header}
                          </option>
                        );
                      })}
                  </StyledConnections>
                </FormControl>
              </div>
            )}
          </Panel>
        </StyledPanel>

        {/* Sidebar Styling Panel */}
        {filtering && (
          <StyledPanel>
            <Panel
              title={<Label style={StyledPanelTitle}>Sidebar Styling</Label>}
              icon={Arrow}
              data-test-id="sidebar-styling-panel"
            >
              {/* Background Color */}
              <div
                style={{
                  marginBottom: '1rem',
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                <MainLabelStyles>Background Color</MainLabelStyles>
                <ColorButtonWrapper
                  id="sidebar-background-color"
                  data-test-id="sidebar-background-color-button"
                  onClick={handleColorEditClick}
                >
                  <ColorButton
                    disabled={false}
                    color={sidebarBackgroundColor}
                  />
                </ColorButtonWrapper>
              </div>

              {/* Checkbox Button Color */}
              <div style={{ marginBottom: '1rem' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <MainLabelStyles>Checkbox Button Color</MainLabelStyles>
                  <ColorButtonWrapper
                    id="checkbox-button-color"
                    data-test-id="checkbox-button-color-button"
                    onClick={handleColorEditClick}
                  >
                    <ColorButton disabled={false} color={checkboxButtonColor} />
                  </ColorButtonWrapper>
                </div>
              </div>

              {/* Single Color Picker Popover following Background/Border pattern */}
              <StyledPickerPopover
                data-test-id="sidebar-color-picker-popover"
                id={pickerId}
                open={pickerOpen}
                onClick={handlePickerClick}
                onClose={handlePickerClose}
                anchorEl={colorButtonRef.current}
                anchorOrigin={{
                  vertical: 'center',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'center',
                  horizontal: 'right',
                }}
              >
                <StyledPickerWrapper>
                  <StyledPickerHeader data-test-id="styled-picker-header">
                    Color Selector
                  </StyledPickerHeader>
                  <StyledClose
                    data-test-id="close-icon"
                    onClick={handlePickerClose}
                  />
                </StyledPickerWrapper>
                <GradientColorPicker
                  site={site}
                  handleColorChange={handleColorChange}
                  updateSite={updateSite}
                  saveSite={saveSite}
                  anchorEl={colorButtonRef.current}
                  value={
                    colorButtonRef.current?.id === 'sidebar-background-color'
                      ? sidebarBackgroundColor
                      : colorButtonRef.current?.id === 'sidebar-heading-color'
                      ? sidebarHeadingColor
                      : colorButtonRef.current?.id === 'checkbox-button-color'
                      ? checkboxButtonColor
                      : sidebarOptionColor
                  }
                  onChange={handleColorChange}
                />
              </StyledPickerPopover>

              {/* Heading Typography */}
              <div style={{ marginBottom: '1.5rem' }}>
                <LabelStyles>Sidebar Heading Typography</LabelStyles>

                {/* Font and Font Size Row */}
                <StyledWrapper>
                  <MainLabelStyles>Font</MainLabelStyles>
                  <FontSelect
                    onChange={handleSidebarHeadingFontChange}
                    value={sidebarHeadingFont}
                    data-test-id="sidebar-heading-font-select"
                  >
                    {Object.keys(getCombinedFontsForTheme()).map(f => (
                      <option value={f} key={f}>
                        {f}
                      </option>
                    ))}
                  </FontSelect>
                  <FontSizeInputWrapper>
                    <FontSizeInput
                      type="number"
                      value={sidebarHeadingFontSize}
                      onChange={handleSidebarHeadingFontSizeChange}
                      min="8"
                      max="72"
                      data-test-id="sidebar-heading-font-size"
                    />
                    <FontSizeUnitStyle>px</FontSizeUnitStyle>
                  </FontSizeInputWrapper>
                </StyledWrapper>

                {/* Style Options Row */}
                <StyleWrapper>
                  <MainLabelStyles>Style</MainLabelStyles>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarHeadingBold}
                      disabled={false}
                      onClick={handleSidebarHeadingBoldToggle}
                      data-test-id="sidebar-heading-bold"
                      title="Bold"
                    >
                      <IconBold />
                    </StyledIcon>
                  </TextIconWrapper>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarHeadingItalic}
                      disabled={false}
                      onClick={handleSidebarHeadingItalicToggle}
                      data-test-id="sidebar-heading-italic"
                      title="Italic"
                    >
                      <IconItalic />
                    </StyledIcon>
                  </TextIconWrapper>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarHeadingUnderline}
                      disabled={false}
                      onClick={handleSidebarHeadingUnderlineToggle}
                      data-test-id="sidebar-heading-underline"
                      title="Underline"
                    >
                      <IconUnderline />
                    </StyledIcon>
                  </TextIconWrapper>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarHeadingStrikeThrough}
                      disabled={false}
                      onClick={handleSidebarHeadingStrikeThroughToggle}
                      data-test-id="sidebar-heading-strikethrough"
                      title="Strikethrough"
                    >
                      <IconStrikethrough />
                    </StyledIcon>
                  </TextIconWrapper>
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <MainLabelStyles>Color</MainLabelStyles>
                    <ColorButtonWrapper
                      id="sidebar-heading-color"
                      data-test-id="sidebar-heading-color-button"
                      onClick={handleColorEditClick}
                    >
                      <ColorButton
                        disabled={false}
                        color={sidebarHeadingColor}
                      />
                    </ColorButtonWrapper>
                  </div>
                </StyleWrapper>
              </div>

              {/* Options Typography */}
              <div style={{ marginBottom: '1rem' }}>
                <LabelStyles>Sidebar Options Typography</LabelStyles>

                {/* Font and Font Size Row */}
                <StyledWrapper>
                  <MainLabelStyles>Font</MainLabelStyles>
                  <FontSelect
                    onChange={handleSidebarOptionFontChange}
                    value={sidebarOptionFont}
                    data-test-id="sidebar-option-font-select"
                  >
                    {Object.keys(getCombinedFontsForTheme()).map(f => (
                      <option value={f} key={f}>
                        {f}
                      </option>
                    ))}
                  </FontSelect>
                  <FontSizeInputWrapper>
                    <FontSizeInput
                      type="number"
                      value={sidebarOptionFontSize}
                      onChange={handleSidebarOptionFontSizeChange}
                      min="8"
                      max="72"
                      data-test-id="sidebar-option-font-size"
                    />
                    <FontSizeUnitStyle>px</FontSizeUnitStyle>
                  </FontSizeInputWrapper>
                </StyledWrapper>

                {/* Style Options Row */}
                <StyleWrapper>
                  <MainLabelStyles>Style</MainLabelStyles>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarOptionBold}
                      disabled={false}
                      onClick={handleSidebarOptionBoldToggle}
                      data-test-id="sidebar-option-bold"
                      title="Bold"
                    >
                      <IconBold />
                    </StyledIcon>
                  </TextIconWrapper>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarOptionItalic}
                      disabled={false}
                      onClick={handleSidebarOptionItalicToggle}
                      data-test-id="sidebar-option-italic"
                      title="Italic"
                    >
                      <IconItalic />
                    </StyledIcon>
                  </TextIconWrapper>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarOptionUnderline}
                      disabled={false}
                      onClick={handleSidebarOptionUnderlineToggle}
                      data-test-id="sidebar-option-underline"
                      title="Underline"
                    >
                      <IconUnderline />
                    </StyledIcon>
                  </TextIconWrapper>
                  <TextIconWrapper>
                    <StyledIcon
                      selected={sidebarOptionStrikeThrough}
                      disabled={false}
                      onClick={handleSidebarOptionStrikeThroughToggle}
                      data-test-id="sidebar-option-strikethrough"
                      title="Strikethrough"
                    >
                      <IconStrikethrough />
                    </StyledIcon>
                  </TextIconWrapper>
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <MainLabelStyles>Color</MainLabelStyles>
                    <ColorButtonWrapper
                      id="sidebar-option-color"
                      data-test-id="sidebar-option-color-button"
                      onClick={handleColorEditClick}
                    >
                      <ColorButton
                        disabled={false}
                        color={sidebarOptionColor}
                      />
                    </ColorButtonWrapper>
                  </div>
                </StyleWrapper>
              </div>
            </Panel>
          </StyledPanel>
        )}

        <StyledPanel>
          <StyledPanel>
            <Panel
              title={<Label style={StyledPanelTitle}>Connections</Label>}
              icon={Arrow}
              data-test-id="connections-panel"
            >
              <div style={{ display: 'flex' }}>
                <Label style={StyledPanelTitle}>Widget</Label>
                <Label style={StyledPanelTitle}>Data Connection</Label>
              </div>
              {childWidgets.map(widget => {
                return (
                  <StyledDataDropdowns key={widget.id}>
                    <MainLabelStyles>
                      {widget.config.label || widget.type}
                    </MainLabelStyles>
                    <FormControl
                      data-test-id="background-style-dropdown"
                      id={'controlled-select'}
                    >
                      <StyledConnections
                        value={
                          widgetDataConnections[
                            widget.config.repeaterWidgetId
                          ] || ''
                        }
                        onChange={e =>
                          handleConnectionChange(widget, e.target.value)
                        }
                        data-test-id={`widget-data-connection-select-${widget.config.repeaterWidgetId}`}
                      >
                        <option value="" disabled>
                          Select column
                        </option>
                        {widgetState.config.repeaterData.headers
                          .filter(
                            header =>
                              header !== 'index' && header !== 'Add Column'
                          )
                          .map(header => {
                            return (
                              <option key={header} value={header}>
                                {header}
                              </option>
                            );
                          })}
                      </StyledConnections>
                    </FormControl>
                  </StyledDataDropdowns>
                );
              })}
            </Panel>
          </StyledPanel>
          <SizeLocationPanel
            title={
              <Label
                style={StyledPanelTitle}
                data-test-id="size-location-panel-toggle"
              >
                Size and Location
              </Label>
            }
            initiallyClosed
            icon={Arrow}
            data-test-id="size-location-panel"
          >
            <WidgetSizeLocation
              activeWidgetId={props.widgetState.id}
              data-test-id="widget-size-location"
              sizeLocation={{
                xLocation: value.xLocation,
                yLocation: value.yLocation,
                width: value.width,
                height: value.height,
                uniqueId: value.uniqueId,
              }}
              updateWidgetSizeLocation={updateWidgetSizeLoction}
            />
          </SizeLocationPanel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>Background</Label>}
            icon={Arrow}
            data-test-id="provisionig-service-panel"
          >
            <Background
              data-test-id="background-component"
              backgroundData={updateBackgroundData}
              backgroundImage={updateBackgroundImage}
              handleBackgroundColor={handleBackgroundColor}
              widgetState={widgetState}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            key="border-panel"
            title={
              <Label
                style={StyledPanelTitle}
                data-test-id="border-panel-toggle"
              >
                Border
              </Label>
            }
            initiallyClosed
            icon={Arrow}
            data-test-id="border-panel"
          >
            <Border
              data-test-id="border-data"
              updateBorderData={updateBorderData}
              handleLineColor={handleLineColor}
              widgetState={widgetState}
              pages={props.pages}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            key="layout-panel"
            title={<Label style={StyledPanelTitle}>Layout</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="layout-panel"
          >
            <MuiOptionsWrapper>
              <MUIFormControl id="post-login-type-radio">
                <RadioGroup
                  name={`postLoginType`}
                  value={layout}
                  onChange={e => handleLayoutChange(e)}
                >
                  <FormControlLabel
                    data-test-id="post-login-type-page-radio-button"
                    value={'horizontal'}
                    control={<StyledRadio disableRipple />}
                    label={'Horizontal'}
                  />
                  <FormControlLabel
                    data-test-id="post-login-type-url-radio-button"
                    value={'vertical'}
                    control={<StyledRadio disableRipple />}
                    label={'Vertical'}
                  />
                </RadioGroup>
              </MUIFormControl>
            </MuiOptionsWrapper>
            {layout === 'horizontal' ? (
              <>
                <Label
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    marginTop: '5px',
                  }}
                >
                  Items per row
                </Label>
                <TextField
                  type="text"
                  value={itemsCount}
                  onChange={handleItemsCountChange}
                  data-test-id="items-count-input"
                  variant="standard"
                  style={{
                    width: '80px',
                    marginLeft: '45px',
                    fontSize: '14px',
                  }}
                />
              </>
            ) : (
              <></>
            )}
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            key="border-panel"
            title={<Label style={StyledPanelTitle}>Pagination</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="border-panel"
          >
            <RequiredFieldWrapper>
              <Label
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                }}
              >
                Show Pagination
              </Label>
              <Checkbox
                data-test-id="required-checkbox"
                checked={enablePagination}
                onChange={handleEnablePaginationChange}
                style={{ marginLeft: '15px' }}
              />
            </RequiredFieldWrapper>
            {enablePagination && (
              <div>
                <Label
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    marginTop: '5px',
                  }}
                >
                  Items per "page"
                </Label>
                <TextField
                  type="text"
                  value={paginatedItemsPerPage}
                  onChange={handlePaginatedItemsPerPageChange}
                  data-test-id="items-per-page-input"
                  variant="standard"
                  style={{
                    width: '80px',
                    marginLeft: '27px',
                    fontSize: '14px',
                  }}
                />
              </div>
            )}
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>Container Spacing</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="container-spacing-panel"
          >
            <ContainerSpacing
              data-test-id="container-spacing-component"
              spacingData={updateContainerSpacingData}
              widgetState={widgetState}
            />
          </Panel>
        </StyledPanel>
      </Panel.Group>
    </>
  );
};

export default RepeaterWidgetControl;
